import { KeyServiceUnavailableError } from './errors';

// Just past API Gateway's 29 s integration timeout, so a slow key service answers first.
const KEY_SERVICE_REQUEST_TIMEOUT_MS = 30_000;

function rejectionOnAbort(signal: AbortSignal): Promise<never> {
  return new Promise((_resolve, reject) => {
    signal.addEventListener('abort', () => reject(signal.reason), { once: true });
  });
}

export async function withinKeyServiceTimeout<T>(
  request: (signal: AbortSignal) => Promise<T>,
  routeSignal: AbortSignal | undefined,
): Promise<T> {
  const attempt = new AbortController();
  const timer = setTimeout(
    () => attempt.abort(new KeyServiceUnavailableError()),
    KEY_SERVICE_REQUEST_TIMEOUT_MS,
  );
  const followRoute = () => attempt.abort(routeSignal?.reason);
  routeSignal?.addEventListener('abort', followRoute);
  try {
    return await Promise.race([request(attempt.signal), rejectionOnAbort(attempt.signal)]);
  } finally {
    clearTimeout(timer);
    routeSignal?.removeEventListener('abort', followRoute);
  }
}
